import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import TargetDescription from 'apps/personal/components/targets/description';
import TargetRange from 'apps/personal/components/targets-target-range';
import onWindowResize from 'library/hoc/on-window-resize';

const TargetGroupingNavigation = ({ id, characteristic, active, setActive }) => (
  <a key={id} className={active?'active':''} onClick={()=>setActive(id)} href="javascript:void(0)">{ characteristic.name }</a>
);
const TargetGroupingOption = ({ id, characteristic, active }) => (
  <option value={id}>{ characteristic.name }</option>
);

const TargetGroupingList = onWindowResize(({ windowWidth, setActive, active=null, target_map: {gap=[], match=[]}}) => {
  if (windowWidth <= 796) {
    return (
      <label>
        Behavior or Mindset
        <select value={active} name="target-grouping" onChange={(e)=>setActive(e.target.value)}>
          {
            match.length
              ? <optgroup label={trans`MATCH`} />
              : null
          }
          { match.map(({id, characteristic})=><TargetGroupingOption key={id} id={id} characteristic={characteristic} />) }
          {
            gap.length
              ? <optgroup label={trans`GAP`} />
              : null
          }
          { gap.map(({id, characteristic})=><TargetGroupingOption key={id} id={id} characteristic={characteristic} />) }
        </select>
      </label>
    );
  }

  return (
    <div className="personal-target-grouping-targets-list">
      {
        match.length
          ? <label key="match-label">{trans`MATCH`}</label>
          : null
      }
      { match.map(({id, characteristic})=><TargetGroupingNavigation setActive={setActive} active={id===active} key={id} id={id} characteristic={characteristic} />) }
      {
        gap.length
          ? <label key="gap-label">{trans`GAP`}</label>
          : null
      }
      { gap.map(({id, characteristic})=><TargetGroupingNavigation setActive={setActive} active={id===active} key={id} id={id} characteristic={characteristic} />) }
    </div>
  );
});

class TargetGroupingData extends React.Component {
  static propTypes = {
    targets: PropTypes.array
  }

  state = {
    target_map: {
      gap: [],
      match: []
    },
    active: null
  }

  componentWillMount() {
    this.setTargetMap(this.props.targets);
  }

  componentWillReceiveProps(nextProps) {
    this.setTargetMap(nextProps.targets);
  }

  setTargetMap = (targets) => {
    const target_map = {
      match: [],
      gap: []
    };

    for (const target of targets) {
      const { start, end } = target.percentile_range;
      const score = target.characteristic.score;
      if (score <= end && score >= start) {
        target_map.match.push(target);
      } else {
        target_map.gap.push(target);
      }
    }

    target_map.gap = target_map.gap.sort((a,b)=>a.characteristic.name.toUpperCase()<b.characteristic.name.toUpperCase()?-1:1);
    target_map.match = target_map.match.sort((a,b)=>a.characteristic.name.toUpperCase()<b.characteristic.name.toUpperCase()?-1:1);

    this.setState({
      target_map: target_map,
      active: this.state.active || (target_map.match[0]||target_map.gap[0]).id
    });
  }

  setActive = (id) => {
    this.setState({
      active: id
    });
  }

  render() {
    const { active, target_map } = this.state;
    const { gap, match } = target_map;

    const active_target = gap.find(({id})=>id==active) || match.find(({id})=>id==active);

    return (
      <Fragment>
        <TargetGroupingList setActive={this.setActive} active={active} target_map={target_map} />
        <div className="personal-target-grouping-targets-body">
          <TargetRange target={active_target} />
          <TargetDescription target={active_target} />
        </div>
      </Fragment>
    );
  }
}

export default TargetGroupingData;
